import { render, staticRenderFns } from "./AiSummary.vue?vue&type=template&id=709d5e85&scoped=true"
import script from "./AiSummary.vue?vue&type=script&lang=js"
export * from "./AiSummary.vue?vue&type=script&lang=js"
import style0 from "./AiSummary.vue?vue&type=style&index=0&id=709d5e85&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709d5e85",
  null
  
)

export default component.exports